import React from "react";
import { Button } from "primereact/button";
import axios from "axios";
import { useHistory } from "react-router-dom";
import localeText from "../../../../../../locale";
import apiURI from "../../../../../../service/Api";

const SettingsPageHeader = ({ plan, onLogout }) => {
  const history = useHistory();
  const showUpgrade = plan === "Customer" || plan === "Partner" || plan === "Seller";

  async function handleLogout() {
    if (typeof onLogout === "function") {
      onLogout();
      return;
    }

    if (localStorage.getItem("__extraconomy_devicetoken__")) {
      try {
        const token = localStorage.getItem("__extraconomy_token");
        const username = localStorage.getItem("__extraconomy_username");
        const deviceId = localStorage.getItem("__extraconomy_devicetoken__");
        await axios({
          method: "post",
          url: `${apiURI}/device/unregisterdevice`,
          data: { user: { username }, deviceid: JSON.parse(deviceId) },
          headers: { Authorization: "Bearer " + token },
        });
      } catch (e) {}
    }

    if (JSON.parse(localStorage.getItem("__extraconomy_ismobile__") || "false")) {
      localStorage.removeItem("__extraconomy_token");
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ isLogout: true }));
      }
    }

    localStorage.removeItem("__extraconomy_token");
    localStorage.removeItem("__extraconomy_username");
    localStorage.removeItem("__extraconomy_order");
    localStorage.removeItem("__extraconomy_order_fringe_benefit");
    window.location.replace("/login");
  }

  return (
    <>
      <div className="flex align-items-center justify-content-between gap-3 flex-wrap mb-3">
        <div className="flex align-items-center gap-4">
          <div
            className="border-circle p-3"
            style={{
              border: "1px solid var(--theme-border, #EBEBEB)",
              width: "54px",
              height: "54px",
            }}
          >
            <i
              className="pi pi-user text-xl"
              style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
            />
          </div>
          <div>
            <h2 className="text-lg font-semibold m-0" style={{ color: "var(--theme-text)" }}>
              {localeText("settingsPageProfileInfoTitle") || "Informações de Perfil"}
            </h2>
            <p className="text-sm m-0 mt-1" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
              {localeText("settingsPageSubtitle") || "Gerencie suas preferências e opções."}
            </p>
          </div>
        </div>

        <div className="flex gap-2">
          <Button
            label={localeText("logout")}
            icon="pi pi-sign-out"
            className="p-button-outlined border-round-md p-no-outline"
            style={{ borderColor: "var(--theme-primary)", color: "var(--theme-primary)" }}
            onClick={handleLogout}
          />
        </div>
      </div>
      <hr className="mb-0" />
    </>
  );
};

export default SettingsPageHeader;
